import { useUpdatedRef } from '@sail/react';
import { noop, once } from '@sail/utils';
import { useMemo } from 'react';
import { UninitializedObservabilityProviderError } from '../internal/common/errors';
import logErrorInDev from '../internal/common/logErrorInDev';
import { useObservabilityApi } from '../internal/provider/ObservabilityApiProvider';
const logUninitializedErrorOnce = once(()=>{
    logErrorInDev(new UninitializedObservabilityProviderError('useReports'));
});
const defaultReports = {
    error: noop,
    warning: noop
};
// WeakMap to store reports objects by provider instance
const providerReportsMap = new WeakMap();
/**
 * @see https://sail.stripe.me/apis/observability/useReports
 */ export default function useReports() {
    const api = useObservabilityApi();
    const apiRef = useUpdatedRef(api);
    return useMemo(()=>{
        // eslint-disable-next-line react-hooks/refs
        const currentApiValue = apiRef.current;
        // eslint-disable-next-line react-hooks/refs
        if (!currentApiValue) {
            logUninitializedErrorOnce();
            return defaultReports;
        }
        // Check if we already have reports for this provider
        let reports = providerReportsMap.get(currentApiValue);
        if (!reports) {
            reports = {
                error (...args) {
                    var _apiRef_current_reports, _apiRef_current;
                    return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : (_apiRef_current_reports = _apiRef_current.reports) === null || _apiRef_current_reports === void 0 ? void 0 : _apiRef_current_reports.error(...args);
                },
                warning (...args) {
                    var _apiRef_current_reports, _apiRef_current;
                    return (_apiRef_current = apiRef.current) === null || _apiRef_current === void 0 ? void 0 : (_apiRef_current_reports = _apiRef_current.reports) === null || _apiRef_current_reports === void 0 ? void 0 : _apiRef_current_reports.warning(...args);
                }
            };
            // eslint-disable-next-line react-hooks/refs
            providerReportsMap.set(currentApiValue, reports);
        }
        return reports;
    }, [
        apiRef
    ]);
}

//# sourceMappingURL=useReports.js.map